export default "__VITE_ASSET__lA_aqXN___"